/* eslint-disable @next/next/no-img-element */
import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { ElementDataType } from '@/components/sections/builder/elements/body/multicolumn/type';
import { cn } from '@/lib/utils';
import clsx from 'clsx';

export default function ElementContent({ element, preview }: ElementProps) {
  const content = element.data as ElementDataType;

  const childs = element.childs;

  return (
    <>
      <section className={cn('textwithicon_wrapper')}>
        <div className='theme_layout_page_width mx-auto duration-100'>
          <div
            className={clsx(
              'px-4 lg:px-6',
              content.columnAlignment === 'center' && 'text-center',
              content.columnAlignment === 'left' && 'text-left'
            )}
          >
            <h2
              className={clsx(
                'text-heading theme_font_heading mb-4 text-3xl tracking-tight',
                content.headingSize === 'large' && 'text-4xl @sm:text-4xl md:text-5xl lg:text-6xl',
                content.headingSize === 'medium' && 'text-3xl @sm:text-3xl md:text-4xl lg:text-5xl',
                content.headingSize === 'small' && 'text-2xl @sm:text-2xl md:text-3xl lg:text-4xl'
              )}
              data-animation='true'
              dangerouslySetInnerHTML={{ __html: content.heading }}
            />
            <div className='desktop-grid-col grid grid-cols-1 gap-y-2 md:grid-cols-3 md:gap-y-4 lg:gap-y-6'>
              {childs?.map((child) => (
                <WrapperChild
                  child={{
                    ...child,
                    parentData: content,
                  }}
                  parentType={element.type}
                  key={child.id}
                  preview={preview}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          @media (min-width: 1024px) {
            .desktop-grid-col {
              grid-template-columns: repeat(${content.numberOfColumns || 1}, minmax(0, 1fr));
            }
          }
          .textwithicon_wrapper {
            background-color: ${content.colorScheme?.background || 'white'};
            color: ${content.colorScheme?.text || '#52535B'} !important;
            padding-top: ${content.topPadding}px;
            padding-bottom: ${content.bottomPadding}px;
          }
          .textwithicon_heading {
            font-size: ${content.headingSize}px;
            line-height: ${content.headingSize}px;
            color: ${content.colorScheme?.text || '#52535B'} !important;
          }
          .text_heading {
            color: ${content.colorScheme?.text || '#111827'};
          }
        `}
      </style>
    </>
  );
}
